<template lang="html">
  <span class="cancelar-nfe">
    <a
      class="button-invoices"
      title="Cancelar"
      @click.prevent="openModal"
    >
      <i class="fa fa-times invoice-icon" />
    </a>

    <modal
      title="Cancelar Nota Fiscal"
      save-button-text="Cancelar"
      :is-visible="isVisible"
      :close-modal="closeModal"
      :save-button="cancelNfce"
    >
      <form @submit.prevent="cancelNfce">
        <div class="field">
          <p class="control">
            <strong>Atenção:</strong> <br> Atualmente o prazo máximo para cancelamento de uma NF-e é de 24 horas, após a emissão da mesma.
          </p>
          <label class="label">Justificativa</label>

          <p class="control">
            <textarea
              v-model="customer_invoice.justification"
              class="textarea"
              placeholder="Exemplo: Nota fiscal emitida incorretamente..."
            />
          </p>
        </div>
      </form>
    </modal>
  </span>
</template>

<script>
import { isEmpty } from 'lodash';
import { http } from 'app/v1/src/plugins/http';
import { getData } from 'app/v1/src/utils/get';
import Modal from 'app/v1/src/components/Modal';

export default {

  components: {
    Modal
  },

  props: {
    id: {
      type: String,
      require: true,
      default: ''
    }
  },
  data() {
    return {
      isVisible: false,
      customer_invoice: {
        justification: ''
      },
    };
  },

  methods: {
    openModal() {
      this.isVisible = true;
    },

    closeModal() {
      this.isVisible = false;
    },

    hasJustification() {
      return !isEmpty(this.customer_invoice.justification);
    },

    greaterJustification() {
      return this.customer_invoice.justification.length > 20;
    },

    cancelNfce() {
      if(this.hasJustification() && this.greaterJustification()) {
        this.handlecancelNfce();
      }
    },

    handlecancelNfce() {
      const { customer_invoice } = this;
      http.post(`/api/customer_invoices/${this.id}/cancel`, { customer_invoice })
        .then(getData)
        .then(() => {
          this.closeModal();
          this.customer_invoice.justification = '';
        })
        .catch(() => Promise.reject('FAIL_IN_CANCEL_INVOICE'));
    }
  }
};
</script>
